export default "__VITE_ASSET__55f29222__"